var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2d6f6840515698a940b39bc3a84a14e91e54071e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prebuilt-ui@pluot-communications"]={id:"2d6f6840515698a940b39bc3a84a14e91e54071e"};
      